/** Chunk load error messages for Sentry `ignoreErrors`, matching only the part that is stable across chunk hashes. */
export const CHUNK_LOAD_ERROR_IGNORE_PATTERNS: RegExp[] = [
  /Failed to fetch dynamically imported module/,
  /error loading dynamically imported module/,
  /Importing a module script failed/,
];
